import { render } from "./PrivilegeMessage.vue?vue&type=template&id=8de0d072&scoped=true"
import script from "./PrivilegeMessage.vue?vue&type=script&lang=js"
export * from "./PrivilegeMessage.vue?vue&type=script&lang=js"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8de0d072"]])

export default __exports__